/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum BoughtCreditStateEnum {
    Request = 'REQUEST',
    Bought = 'BOUGHT'
}

export function BoughtCreditStateEnumFromJSON(json: any): BoughtCreditStateEnum {
    return BoughtCreditStateEnumFromJSONTyped(json, false);
}

export function BoughtCreditStateEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoughtCreditStateEnum {
    return json as BoughtCreditStateEnum;
}

export function BoughtCreditStateEnumToJSON(value?: BoughtCreditStateEnum | null): any {
    return value as any;
}

